import { useEffect } from 'react';

export const useRemoveModal = () => {
	useEffect(() => {
		document.querySelector('aside.layout-aside')?.remove?.();

		const interval = setInterval(() => {
			document.querySelector('aside.layout-aside')?.remove?.();
		}, 500);

		return () => {
			clearInterval(interval);
		};
	}, []);
};
